import React from "react";
import classNames from "classnames";
import { IconProps, IconDimensions } from "../../types";
import { getIconDimensions } from "../../../utils/icon-utils";

export const IconDataTransferBoth = ({
  title,
  titleId,
  color,
  className: classNameProp,
  size,
  height,
  width,
  ...restProps
}: IconProps) => {
  const className = classNames(
    {
      [`text-${color}`]: color !== undefined,
    },
    classNameProp
  );

  const defaultDimensions: IconDimensions = {
    height: 24,
    width: 24,
  };
  const props = {
    className,
    ...getIconDimensions(size, width, height, defaultDimensions?.width, defaultDimensions?.height),
    ...restProps,
  };

  return (
    <svg viewBox="0 0 24 24" fill="currentcolor" {...props}>
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 3.6a.6.6 0 01.601-.6H7.4a.6.6 0 01.6.6v13.81l1.026-1.084a.6.6 0 01.849-.015l.007.008.01.01.577.606a.6.6 0 01-.002.83l-2.754 2.893a.976.976 0 01-1.415 0l-2.76-2.9a.6.6 0 01-.013-.818l.563-.622a.6.6 0 01.876-.013L6 17.398V3.6Zm13.917 4.043.563-.622a.6.6 0 00-.013-.818l-2.76-2.9a.976.976 0 00-1.415 0l-2.754 2.894a.6.6 0 00-.002.83l.576.606.01.01.008.007a.6.6 0 00.849-.015l1.026-1.083v13.81a.6.6 0 00.6.6h.799a.6.6 0 00.6-.6V6.563l1.037 1.092.028.028a.6.6 0 00.848-.04Z"
        fill="currentcolor"
      />
    </svg>
  );
};

IconDataTransferBoth.displayName = "IconDataTransferBoth";
